var MultibrandingStatsProviders;
(function(MultibrandingStatsProviders) {
    MultibrandingStatsProviders["VK"] = 'vk';
    MultibrandingStatsProviders["OK"] = 'ok_ru';
    MultibrandingStatsProviders["MAIL"] = 'mail_ru';
})(MultibrandingStatsProviders || (MultibrandingStatsProviders = {}));

export { MultibrandingStatsProviders };
